import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '~ui-kit';
import { lighterBlue } from '~theme';

/**
 * @deprecated use PillSelect instead
 */
const Tags = ({ value, onChange, options, name, error, multi, ...props }) => {
  const handleClick = (event, newValue) => {
    event.preventDefault();
    if (multi) {
      if (value.includes(newValue)) {
        onChange(value.filter(v => v !== newValue));
      } else {
        onChange([...value, newValue]);
      }
    } else {
      onChange(newValue);
    }
  };

  return (
    <Container {...props}>
      {options?.map(o => {
        const active = multi ? value.includes(o.value) : o.value === value;

        return (
          <Tooltip content={o.tooltip} key={o.value}>
            <Tag
              id={o.value}
              role="button"
              active={active}
              onClick={event => !o.disabled && handleClick(event, o.value)}
              error={error}
              disabled={o.disabled}
            >
              {o.label}
            </Tag>
          </Tooltip>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const Tag = styled.button`
  background-color: ${p => (p.active ? lighterBlue : 'unset')};
  color: ${p => (p.active ? 'white' : 'black')};
  border: 2px solid ${p => (p.error ? 'var(--errorColor)' : lighterBlue)};
  border-radius: 16px;
  padding: 0.4rem 1.6rem;
  transition: all 0.1s ease-in-out;

  ${p =>
    p.disabled &&
    `
    opacity: 0.3;
    cursor: not-allowed;
  `}
`;

export default Tags;
